import { createPortal } from "react-dom";
import { SplashStage } from "./SplashStage";

type Props = {
  // When true the overlay is hidden + non-interactive (fade-out state).
  fading: boolean;
};

// Fixed full-screen branded splash overlay. Used by the boot Loader and the
// language-switch overlay so both share one canonical visual. Portaled to
// <body>: mounted in place it sits inside the .route-fade wrapper, whose
// opacity animation creates a stacking context that traps the overlay's
// z-index below sibling fixed UI (e.g. the global MuteToggle).
export function MeridianSplash({ fading }: Props) {
  return createPortal(
    <div
      className={`ld-meridian-overlay ${
        fading ? "opacity-0 pointer-events-none" : "opacity-100 pointer-events-auto"
      }`}
    >
      <SplashStage />
    </div>,
    document.body
  );
}
